import { TimeInterval } from '@cotera/api';

export const atcQueryKeys = {
  all: ['atc-visibility'] as const,
  statusSummary: (timeInterval: TimeInterval) =>
    ['atc-visibility', 'status-summary', timeInterval] as const,
  failureTypes: (timeInterval: TimeInterval) =>
    ['atc-visibility', 'failure-types', timeInterval] as const,
  failureTypeDetails: (orgId: string, runId: string) =>
    ['atc-visibility', 'failure-type-details', orgId, runId] as const,
  invocationSummary: (timeInterval: TimeInterval) =>
    ['atc-visibility', 'invocation-summary', timeInterval] as const,
  stackFramesBreakdown: (timeInterval: TimeInterval) =>
    ['atc-visibility', 'stack-frames-breakdown', timeInterval] as const,
  activeInvocationsByOrg: () =>
    ['atc-visibility', 'active-invocations-by-org'] as const,
  restateUrl: () => ['atc-visibility', 'restate-url'] as const,
  sagaInvocations: (
    timeInterval: TimeInterval,
    filter?: { include?: string; exclude?: string[] }
  ) =>
    [
      'atc-visibility',
      'saga-invocations',
      timeInterval,
      filter?.include ?? null,
      (filter?.exclude ?? []).join(','),
    ] as const,
  organizationsByIds: (orgIds: string[]) =>
    ['organizations', 'by-ids', orgIds] as const,
  webhookTriggers: (timeInterval: TimeInterval) =>
    ['atc-visibility', 'webhook-triggers', timeInterval] as const,
};
